import { useQuery } from '@tanstack/react-query';
import { getSdk } from '@/lib/sdk';

export const searchKeys = {
  all: ['search'] as const,
  users: (query: string) => ['search', 'users', query] as const,
  usersAutocomplete: (query: string) => ['search', 'usersAutocomplete', query] as const,
  audio: (query: string) => ['search', 'audio', query] as const,
  hashtags: (query: string) => ['search', 'hashtags', query] as const,
};

/**
 * Search users by query string.
 */
export function useSearchUsers(query: string) {
  const sdk = getSdk();

  return useQuery({
    queryKey: searchKeys.users(query),
    queryFn: async () => {
      const response = await sdk.searchUsers(query);
      return response.data;
    },
    enabled: query.length >= 2,
  });
}

/**
 * Autocomplete user search (faster, fewer fields).
 */
export function useSearchUsersAutocomplete(query: string) {
  const sdk = getSdk();

  return useQuery({
    queryKey: searchKeys.usersAutocomplete(query),
    queryFn: async () => {
      const response = await sdk.searchUsersAutocomplete(query);
      return response.data;
    },
    enabled: query.length >= 2,
  });
}

/**
 * Search audio/songs.
 */
export function useSearchAudio(query: string) {
  const sdk = getSdk();

  return useQuery({
    queryKey: searchKeys.audio(query),
    queryFn: async () => {
      const response = await sdk.searchAudio(query);
      return response.data;
    },
    enabled: query.length >= 2,
  });
}

/**
 * Search hashtags.
 */
export function useSearchHashtags(query: string) {
  const sdk = getSdk();

  return useQuery({
    queryKey: searchKeys.hashtags(query),
    queryFn: async () => {
      const response = await sdk.searchHashtags(query);
      return response.data;
    },
    enabled: query.length >= 2,
  });
}
